import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import Breadcrumb from "../ProfileCommon/Breadcrumb";
import ProfileChevron from "../ProfileCommon/ProfileChevron";
import ProfileAccordion from "../ProfileCommon/ProfileAccordion";
import Search from "../../../components/common/Field/Search";
import { useFAQ } from "../../../hooks/useFAQ";
import LoadingCommon from "../../../components/common/LoadingStatus/LoadingCommon";
import { AnswerWithLink } from "../../../Utils/helper";
import FooterContact from "../../../components/Footer/FooterContact";

const Faq = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getAllFAQSections, searchFAQ } = useFAQ();
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const faqSections = isSearching ? searchFAQ(searchTerm) : getAllFAQSections();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleSectionClick = (sectionKey) => {
    const urlPath = sectionKey.replace(/([A-Z])/g, "-$1").toLowerCase();
    navigate(`/profile/support/faq/${urlPath}`);
  };

  const handleSearchChange = (value) => {
    const searchValue =
      typeof value === "string" ? value : value?.target?.value || "";
    setSearchTerm(searchValue);
    setIsSearching(searchValue.trim() !== "");
  };

  // Function để highlight text
  const highlightText = (text, searchTerm) => {
    if (!searchTerm) return text;

    const regex = new RegExp(`(${searchTerm})`, "gi");
    const parts = text.split(regex);

    return parts.map((part, index) =>
      regex.test(part) ? (
        <span key={index} className="bg-yellow-200 font-medium">
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  return (
    <div className="flex flex-col w-full max-w-[480px] h-full bg-white overflow-y-auto">
      <LoadingCommon statusLoading={isLoading} />
        <div className="flex flex-col gap-2 flex-1 px-[30px] pb-[120px]">
          <Breadcrumb
            breadCrumbTiltle={t("profile.faq")}
            onClickBack={() =>
              navigate("/profile/support", {
                state: { direction: -1 },
                replace: false,
              })
            }
            classNameTitle="text-[#333333] mb-4"
          />

          <Search
            searchQuery={searchTerm}
            onSearchChange={handleSearchChange}
            placeholder={t("base.search")}
            showFavorites={false}
          />

          {isSearching ? (
            <div className="space-y-3">
              {faqSections.length > 0 ? (
                faqSections.map((section, sectionIndex) => (
                  <div key={sectionIndex}>
                    <div className="flex items-center justify-between py-2 mb-2">
                      <h3 className="text-lg font-medium text-[#333] flex items-center">
                        <span className="bg-blue-500 text-white text-xs px-2 py-1 rounded-full mr-2 min-w-[24px] text-center">
                          {section.detail.length}
                        </span>
                        {highlightText(section.title, searchTerm)}
                      </h3>
                    </div>

                    <div className="space-y-0">
                      {section.detail.map((item, itemIndex) => (
                        <ProfileAccordion
                          key={itemIndex}
                          title={
                            <div className="flex items-start w-full">
                              <span className="flex-1">
                                {highlightText(item.question, searchTerm)}
                              </span>
                            </div>
                          }
                          defaultOpen={false}
                        >
                          <div className="pl-6">
                            {/* <p className="text-[16px] text-[#A0A0A0] font-medium leading-relaxed">
                              {highlightText(item.answer, searchTerm)}
                            </p> */}
                            <AnswerWithLink
                              answer={item.answer}
                              searchTerm={searchTerm}
                            />
                          </div>
                        </ProfileAccordion>
                      ))}
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-8">
                  <div className="text-gray-500">
                    <p className="text-lg">
                      No results found for "
                      <span className="font-semibold">{searchTerm}</span>"
                    </p>
                  </div>
                </div>
              )}
            </div>
          ) : (
            faqSections.map((section, index) => (
              <ProfileChevron
                key={index}
                title={section.title}
                onClick={() => handleSectionClick(section.key)}
              />
            ))
          )}
        </div>
      <FooterContact className={"!bg-white"} />
    </div>
  );
};

export default Faq;
